class HeavyEquipmentShop extends HTMLElement {
    constructor() {
        super();
        this.heavyEquipJsonData = null;
        this.uniqueCategories = [];
        this.elements = {};
        this.selectedData = {
            equipment_category: '',
            equipment_manufacturer: '',
            equipment_model_number: ''
        };
        this.initJsonData();
    }

    async initJsonData() {
        try {
            const json = await vehicleUtility.tsvheavyEqJSON();
            this.initVehicle(json);
        } catch (error) {
            console.error('Failed to load vehicle data:', error);
        }
    }

    initVehicle(json) {
        this.heavyEquipJsonData = json;
        this.uniqueCategories = [...new Set(Object.values(json)
            .map(item => item.equipment_category)
            .filter(Boolean))];
        this.cacheElements();
        this.bindEvents();

        const limitedSuggestions = this.uniqueCategories.slice(0, 3);

        const container = this.querySelector("[data-vehicle-suggestion]");
        const suggestionBox = this.querySelector(`[data-vehicle-suggestion-box]`);

        if (!container || !suggestionBox) return;

        container.innerHTML = '';

        limitedSuggestions.forEach(item => {
            const formattedText = item.replace(/\s?\|\s?/g, ' ');
            
            const li = this.createElement('li', formattedText, {
                'data-vehicle-value': '',
                'data-vehicle-model-value': item,
                class: 'block__vehicle-lookup-input-result-li'
            });

            li.addEventListener('click', (e) => {
                container.querySelectorAll("li").forEach((list) => {
                    list.classList.remove("selected");
                });
                e.target.classList.add("selected");
                let targetMakeModel = e.target.getAttribute("data-vehicle-model-value");
                var makeModelValue = e.target.textContent;

                this.selectedData.equipment_category = targetMakeModel;

                e.target.closest(".block__vehicle-lookup-input-box").querySelector('[data-search-vehicle-make-model]').value = makeModelValue;
                e.target.closest(".block__vehicle-lookup-input-box").querySelector('[data-search-vehicle-submit]').classList.remove("d-none");
            });
            container.appendChild(li);
        });
    }

    cacheElements() {
        const selectors = {
            makeModelInput: '[data-search-vehicle-make-model]',
            makeModelList: '[data-search-vehicle-make-model-list]',
            makeModelBox: '[data-selected-vehicle-make-model]',
            submitButton: '[data-search-vehicle-submit]',
            trimInput: '[data-search-vehicle-trim]',
            trimList: '[data-search-vehicle-trim-list]',
            trimBox: '[data-selected-vehicle-trim]',
            trimSubmitButton: '[data-search-vehicle-trim-submit]',
            trimBothSuggestionBox: '[data-trim-both-suggestion-box]',
            cabTypeInput: '[data-search-vehicle-cabType]',
            cabTypeList: '[data-search-vehicle-cabType-list]',
            cabTypeBox: '[data-selected-vehicle-cabType]',
            cabTypeSubmitButton: '[data-search-vehicle-cabType-submit]',
            cabTypeBothSuggestionBox: '[data-cabtype-both-suggestion-box]'
        };

        Object.entries(selectors).forEach(([key, selector]) => {
            this.elements[key] = this.querySelector(selector);
        });
    }

    bindEvents() {
        if (!this.elements.makeModelInput) return;

        // Search configurations - consolidated into single array
        const searchConfigs = [
            {
                input: this.elements.makeModelInput,
                list: this.elements.makeModelList,
                box: this.elements.makeModelBox,
                submit: this.elements.submitButton,
                type: 'category',
                minLength: 3,
                field: 'equipment_category',
                attribute: 'data-vehicle-model-value'
            },
            {
                input: this.elements.trimInput,
                list: this.elements.trimList,
                box: this.elements.trimBox,
                submit: this.elements.trimSubmitButton,
                suggestionBox: this.elements.trimBothSuggestionBox,
                type: 'manufacturer',
                minLength: 3,
                field: 'equipment_manufacturer',
                attribute: 'data-vehicle-trim-value'
            },
            {
                input: this.elements.cabTypeInput,
                list: this.elements.cabTypeList,
                box: this.elements.cabTypeBox,
                submit: this.elements.cabTypeSubmitButton,
                suggestionBox: this.elements.cabTypeBothSuggestionBox,
                type: 'model',
                minLength: 3,
                field: 'equipment_model_number',
                attribute: 'data-vehicle-cabType-value'
            }
        ];

        // Bind all search events
        searchConfigs.forEach(config => this.bindSearchConfig(config));
        
        // Bind step back events
        this.bindStepBackEvents();
    }

    bindSearchConfig(config) {
        if (!config.input) return;

        let debounceTimer;
        
        // Search input handler
        config.input.addEventListener('keyup', (e) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => this.handleSearch(e, config), 150);
        });

        // Selection handler
        const clickTarget = config.suggestionBox || config.list;
        clickTarget?.addEventListener('click', (e) => this.handleSelection(e, config));
        
        // Submit handler
        config.submit?.addEventListener('click', (e) => this.handleSubmit(e, config));
    }

    bindStepBackEvents() {
        document.addEventListener('click', (e) => {
            const backButton = e.target.closest('[data-step-back-btn]');
            if (!backButton) return;

            e.preventDefault();
            const backStep = backButton.getAttribute('data-back-step');
            
            if (backStep && backStep !== '0') {
                this.navigateToPreviousStep(backButton, backStep);
            } else {
                backButton.closest('.block__vehicle-lookup-popup').classList.add('d-none');
            }
        });
    }

    navigateToPreviousStep(button, backStep) {
        const currentStep = button.closest('.block__vehicle-lookup-popup-details');
        const parentEle = currentStep.closest('.block__vehicle-lookup-popup-list');
        
        parentEle.querySelectorAll('.block__vehicle-lookup-popup-details')
            .forEach(step => step.classList.add('d-none'));
            
        const previousStep = parentEle.querySelector(`[current-step="${backStep}"]`);
        previousStep?.classList.remove('d-none');
    }

    handleSearch(e, config) {
        const query = e.target.value.toLowerCase().replace(/\s+/g, ' ').trim();
        const inputBox = e.target.closest(".block__vehicle-lookup-input-box");
        
        // Toggle active state
        inputBox.classList.toggle("active-value", query !== '');
        this.elements.submitButton.removeAttribute("data-complete-selection");
        
        // Reset submit button and clear results
        config.submit?.classList.add('d-none');
        config.list.innerHTML = '';

        if (!query) {
            config.box?.classList.add('d-none');
            return;
        }

        if (query.length >= config.minLength) {
            const matches = this.getMatches(config.type, query);
            this.populateResults(config, matches);
        } else {
            this.showMinLengthMessage(config);
        }
    }

    getMatches(type, query) {
        switch (type) {
            case 'category':
                // Enhanced logic for category search
                return this.getCategoryMatches(query);
            case 'manufacturer':
                return this.getUniqueOptions('equipment_manufacturer', 
                    { equipment_category: this.selectedData.equipment_category })
                    .filter(man => String(man).toLowerCase().includes(query));
            case 'model':
                const normalize = value => String(value ?? '').toLowerCase();
                return this.getUniqueOptions('equipment_model_number', {
                    equipment_category: this.selectedData.equipment_category,
                    equipment_manufacturer: this.selectedData.equipment_manufacturer
                }).filter(model => String(model).toLowerCase().includes(query));
            default:
                return [];
        }
    }

    getCategoryMatches(query) {
        const vehicleArray = Object.values(this.heavyEquipJsonData);
        
        // Check if query matches any equipment_model_number
        const modelMatches = vehicleArray.filter(item => 
            item.equipment_model_number && 
            String(item.equipment_model_number).toLowerCase().includes(query)
        );

        if (modelMatches.length > 0) {
            // Return combined results with format: "Category | Manufacturer | Model"
            return modelMatches.map(item => ({
                displayText: `${item.equipment_category} ${item.equipment_manufacturer} ${item.equipment_model_number}`,
                category: item.equipment_category,
                manufacturer: item.equipment_manufacturer,
                model: item.equipment_model_number,
                isModelMatch: true
            }));
        } else {
            // Return regular category matches
            return this.uniqueCategories
                .filter(cat => cat.toLowerCase().includes(query))
                .map(cat => ({
                    displayText: cat,
                    category: cat,
                    manufacturer: '',
                    model: '',
                    isModelMatch: false
                }));
        }
    }

    handleSelection(e, config) {
        const target = e.target;
        if (!target.matches(`[${config.attribute}]`)) return;

        const selectedValue = target.getAttribute(config.attribute)?.trim();
        if (!selectedValue) return;

        // Check if this is a model match selection
        const isModelMatch = target.hasAttribute('data-is-model-match');
        
        if (config.type === 'category' && isModelMatch) {
            // Handle model match selection - populate all three fields
            const category = target.getAttribute('data-category');
            const manufacturer = target.getAttribute('data-manufacturer');
            const model = target.getAttribute('data-model');
            
            this.selectedData.equipment_category = category;
            this.selectedData.equipment_manufacturer = manufacturer;
            this.selectedData.equipment_model_number = model;
            
            // Skip to final step since all data is selected
            this.skipToFinalStep(target, selectedValue);
        } else {
            // Regular selection handling
            this.selectedData[config.field] = selectedValue;
            this.updateInputAndUI(target, selectedValue, config);
        }
        
        // Remove active state from input box
        e.target.closest(".block__vehicle-lookup-input-box").classList.remove("active-value");
    }

    skipToFinalStep(targetElement, displayValue) {
        // Update input and UI
        this.elements.makeModelInput.value = displayValue;
        this.elements.submitButton?.classList.remove('d-none');
        this.elements.makeModelBox?.classList.add('d-none');

        // Update selection state
        const container = targetElement.closest('.block__vehicle-lookup-input-box');
        container?.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
        targetElement.classList.add('selected');

        // Mark that this is a complete selection (all fields populated)
        // The finalizeSelection will be called when submit button is clicked
        this.elements.submitButton?.setAttribute('data-complete-selection', 'true');
    }

    handleSubmit(e, config) {
        e.preventDefault();
        
        // Check if this is a complete selection (model match with all fields populated)
        const isCompleteSelection = this.elements.submitButton?.hasAttribute('data-complete-selection');
        
        if (config.type === 'model' || isCompleteSelection) {
            this.finalizeSelection();
        } else {
            this.proceedToNextStep(e.target, config.type);
        }
        
        // Clean up the complete selection attribute
        if (isCompleteSelection) {
            this.elements.submitButton?.removeAttribute('data-complete-selection');
        }
    }

    proceedToNextStep(element, type) {
        this.navigateToNextStep(element);
        
        if (type === 'category') {
            this.updateFinalDisplay('[data-show-final-selected-vehicle]', 
                this.selectedData.equipment_category);
            const matchingTrim = this.getUniqueOptions('equipment_manufacturer', { equipment_category: this.selectedData.equipment_category }).slice(0, 5);
            this.populateSuggestions('[data-trim-suggestion]',matchingTrim, 'trim');
        } else if (type === 'manufacturer') {
            this.updateFinalDisplay('[data-selected-make-model-year-trim]', 
                `${this.selectedData.equipment_manufacturer} ${this.selectedData.equipment_category}`);
            const matchingCabType = this.getUniqueOptions('equipment_model_number', { equipment_category: this.selectedData.equipment_category, equipment_manufacturer: this.selectedData.equipment_manufacturer}).slice(0, 5);
            this.populateSuggestions('[data-cabType-suggestion]', matchingCabType, 'cabType');
        }
    }

    finalizeSelection() {
        document.querySelector(".block__vehicle-lookup-popup:not(.d-none) .block__vehicle-lookup-popup-details:not(.d-none)").querySelector(".block__vehicle-lookup-input-button").classList.add("loading");
        const { equipment_category, equipment_manufacturer, equipment_model_number } = this.selectedData;
        
        // Always create/update vehicle data to ensure it's set as default and currentSelectedData is updated
        const vehicleData = this.createVehicleData(equipment_category, equipment_manufacturer, equipment_model_number);
        this.addVehicleToSelection(vehicleData);

        const partNumbers = this.getPartNumbers(equipment_category, equipment_manufacturer, equipment_model_number);
        this.redirectToResults(partNumbers);
    }

    populateResults(config, matches) {
        config.box?.classList.remove('d-none');
        
        if (matches.length > 0) {
            if (config.type === 'category' && matches[0].isModelMatch !== undefined) {
                // Handle enhanced category results with model matches
                config.list.innerHTML = matches.map(match => {
                    const attributes = match.isModelMatch 
                        ? `${config.attribute}="${match.displayText}" data-is-model-match="true" data-category="${match.category}" data-manufacturer="${match.manufacturer}" data-model="${match.model}"`
                        : `${config.attribute}="${match.displayText}"`;
                    
                    return `<li class="data-vehicle-model-list" ${attributes}>${match.displayText}</li>`;
                }).join('');
            } else {
                // Regular results
                config.list.innerHTML = matches.map(match => 
                    `<li class="data-vehicle-model-list" ${config.attribute}="${match}">${match}</li>`
                ).join('');
            }
        } else {
            config.list.innerHTML = '<li class="data-vehicle-model-list">No results found</li>';
        }
    }

    showMinLengthMessage(config) {
        config.box?.classList.remove('d-none');
        const equipmentType = config.type === 'category' ? 'Heavy Equipment' : 
                            config.type === 'manufacturer' ? 'manufacturer' : 'model';
        config.list.innerHTML = `<li class="data-vehicle-model-list">Please enter at least ${config.minLength} characters of the ${equipmentType}.</li>`;
    }

    populateSuggestions(selector, items, type) {
        const container = this.querySelector(selector);
        const suggestionBox = this.querySelector(`[data-${type}-suggestion-box]`);
        
        if (!container || !suggestionBox) return;
        
        suggestionBox.classList.remove('d-none');
        container.innerHTML = items.map(item => 
            `<li class="block__vehicle-lookup-input-result-li" data-vehicle-${type}-value="${item}">${item}</li>`
        ).join('');
    }

    createElement(tag, textContent, attributes = {}) {
        const element = document.createElement(tag);
        if (textContent) element.textContent = textContent;
        
        Object.entries(attributes).forEach(([key, value]) => {
            if (key === 'class') {
                element.className = value;
            } else {
                element.setAttribute(key, value);
            }
        });
        
        return element;
    }

    updateInputAndUI(targetElement, value, config) {
        // Update input value
        if (config.input) config.input.value = value;
        
        // Show submit button and hide dropdown
        config.submit?.classList.remove('d-none');
        config.box?.classList.add('d-none');

        // Update selection state
        const container = targetElement.closest('.block__vehicle-lookup-input-box');
        container?.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
        targetElement.classList.add('selected');
    }

    navigateToNextStep(element) {
        const currentStep = element.closest('.block__vehicle-lookup-popup-details');
        const nextStepIndex = currentStep.getAttribute('data-next-step');
        const parentEle = currentStep.closest('.block__vehicle-lookup-popup-list');
        
        parentEle.querySelectorAll('.block__vehicle-lookup-popup-details')
            .forEach(step => step.classList.add('d-none'));
        
        const nextStep = parentEle.querySelector(`[current-step="${nextStepIndex}"]`);
        nextStep?.classList.remove('d-none');
    }

    updateFinalDisplay(selector, content) {
        const element = this.querySelector(selector);
        if (element) element.innerHTML = content;
    }

    checkIfVehicleExists(equipment_category, equipment_manufacturer, equipment_model_number) {
        return window.customerSelectedVehicles.heavyVehicle?.some(vehicle =>
            vehicle.equipment_category === equipment_category &&
            vehicle.equipment_manufacturer === equipment_manufacturer &&
            vehicle.equipment_model_number === equipment_model_number
        ) || false;
    }

    createVehicleData(equipment_category, equipment_manufacturer, equipment_model_number) {
        return {
            id: Math.floor(Math.random() * 4000) + 1000,
            equipment_category,
            equipment_manufacturer,
            equipment_model_number,
            default: false
        };
    }

    resetAllVehicleDefaults() {
        const storageKeys = [
            'vehicle_data_side',
            'vehicle_data_sahdt',
            'vehicle_data',
            'turf_data',
            'heavy_equipment_data'
        ];

        storageKeys.forEach(key => {
            try {
                const storedData = localStorage.getItem(key);
                if (storedData) {
                    const vehicles = JSON.parse(storedData);
                    if (Array.isArray(vehicles)) {
                        vehicles.forEach(vehicle => {
                            vehicle.default = false;
                        });
                        localStorage.setItem(key, JSON.stringify(vehicles));
                    }
                }
            } catch (error) {
                console.error(`Error updating ${key}:`, error);
            }
        });
    }

    addVehicleToSelection(vehicleData) {
        const isCustomer = document.body.classList.contains('customer-loggedin');
        
        // Reset all vehicle defaults to false across all storage keys
        this.resetAllVehicleDefaults();
        
        // Set the new vehicle as default: true
        vehicleData.default = true;
        
        if (!window.customerSelectedVehicles) {
            window.customerSelectedVehicles = { heavyVehicle: [] };
        }
        if (!window.customerSelectedVehicles.heavyVehicle) {
            window.customerSelectedVehicles.heavyVehicle = [];
        }

        // Check if vehicle already exists, if so update it, otherwise add it
        const existingIndex = window.customerSelectedVehicles.heavyVehicle.findIndex(
            v => v.equipment_category === vehicleData.equipment_category && 
                 v.equipment_manufacturer === vehicleData.equipment_manufacturer && 
                 v.equipment_model_number === vehicleData.equipment_model_number
        );

        if (existingIndex !== -1) {
            window.customerSelectedVehicles.heavyVehicle[existingIndex] = vehicleData;
        } else {
            window.customerSelectedVehicles.heavyVehicle.push(vehicleData);
        }
        
        // Update currentSelectedData and currentSelectedDataLabels with latest vehicle
        localStorage.setItem('currentSelectedData', JSON.stringify(vehicleData));
        localStorage.setItem('currentSelectedDataLabels', JSON.stringify(vehicleData));

        if (isCustomer && window.shopifyFormUtility) {
            localStorage.removeItem('heavy_equipment_data');
        } else {
            localStorage.setItem('heavy_equipment_data', JSON.stringify(window.customerSelectedVehicles.heavyVehicle));
        }
    }

    getPartNumbers(equipment_category, equipment_manufacturer, equipment_model_number) {
        const vehicleArray = Object.values(this.heavyEquipJsonData);
        const filteredVehicles = vehicleArray.filter(item => 
            item.equipment_category?.toLowerCase() === equipment_category.toLowerCase() &&
            item.equipment_manufacturer?.toLowerCase() === equipment_manufacturer.toLowerCase() &&
            String(item.equipment_model_number || '').toLowerCase() === String(equipment_model_number || '').toLowerCase()
        );

        const uniquePartNumbers = [...new Set(
            filteredVehicles
                .map(item => item.equipment_part_number)
                .filter(Boolean)
        )];
        
        return uniquePartNumbers.map(p => `sku-${p}`).join(',');
    }

    redirectToResults(partNumbers) {
        const isCustomer = document.body.classList.contains('customer-loggedin');
        
        if (isCustomer && window.shopifyFormUtility) {
            shopifyFormUtility._updateCustomerHEMeta(window.customerSelectedVehicles.heavyVehicle, partNumbers);
        } else {
            window.location.href = `/collections/all?filter.p.tag=${partNumbers}`;
        }
    }

    getUniqueOptions(field, filters) {
        const vehicleArray = Object.values(this.heavyEquipJsonData);
        
        const matching = vehicleArray
            .filter(v => 
                Object.entries(filters).every(([key, value]) => 
                    String(v[key] || '').toLowerCase() === String(value || '').toLowerCase()
                )
            )
            .map(v => v[field])
            .filter(Boolean);
        
        return [...new Set(matching)];
    }
}

customElements.define('heavy-equipment-shop', HeavyEquipmentShop);